import { SaveConsolidationRulesMutation } from "~/gql/mutations/produce/consolidationRules.generated";
import {
	GetConsolidationRulesQuery,
	GetConsolidationRulesVersionsQuery
} from "~/gql/queries/produce/consolidationRules.generated";

export const consolidationRulesEndpoints = {
	GetConsolidationRules: {
		providesTags: ["ConsolidationRules"] as AddTagTypes,
		transformResponse: (res: GetConsolidationRulesQuery) => res
	},
	GetConsolidationRulesVersions: {
		providesTags: ["ConsolidationRules"] as AddTagTypes,
		transformResponse: (res: GetConsolidationRulesVersionsQuery) => res
	},
	SaveConsolidationRules: {
		invalidatesTags: (res: SaveConsolidationRulesMutation | undefined) =>
			res?.saveConsolidationRules.success ? ["ConsolidationRules" as const] : [],
		transformResponse: (res: SaveConsolidationRulesMutation) => res
	}
};
